export default "__VITE_ASSET__66f76997__"